<template>
  <div>
    <div style="font-size:14px;font-weight: bold">Material Type{{rightFlag}}：</div>
    <div class="temperature">
      <div class="mt-4 van-row flex">
        <van-radio-group
          v-model="value.materialType2"
          direction="horizontal"
          @change="onMaterialChange"
        >
          <van-radio :name="1" checked-color="#8866f5">SS316</van-radio>
          <van-radio :name="2" checked-color="#8866f5">SS904</van-radio>
        </van-radio-group>
      </div>

      <div v-if="showBaseR" style="margin-top:20px;">Base R1 = {{ doubleR1 }}Ω</div>
      <!-- 曲线2 -->
      <div class="temperature-container">
        <van-row align="center">
          <van-col span="12">
            <div class="flex-col-center">
              <div>Temperature</div>
              <van-stepper
                style="margin-top:10px"
                step="10"
                v-model="value.temperature2"
                @change="onTemperateChange('t')"
                min="0"
                max="1000"
              />
            </div>
          </van-col>
          <van-col span="12">
            <div class="flex-col-center">
              <div>Push Power(W)</div>
              <div>
                <input
                  style="width:100px;text-align: center"
                  v-model.number="value.pushPower2"
                  @input="onTemperateChange('p1')"
                />
              </div>
            </div>
          </van-col>
        </van-row>

        <van-row align="center" style="margin-top:16px" v-if="false">
          <van-col span="12">
            <div class="flex-col-center">
              <div>Proportion</div>
              <div>
                <input
                  style="width:100px;text-align: center"
                  v-model.number="value.proportion2"
                  @input="onTemperateChange('p2')"
                />
              </div>
            </div>
          </van-col>
          <van-col span="12">
            <div class="flex-col-center">
              <div>Integral</div>
              <input
                style="width:100px;text-align: center"
                v-model.number="value.integral2"
                @input="onTemperateChange('i')"
              />
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BLUETOOTH_MODULE_NAME } from "@/bluetooth/store/StoreType";

export default {
  name: "TemperatureSetting2",
  props: {
    value: {
      type: Object,
      require: true
    },
    showBaseR: {
      type: Boolean,
      default: true
    },
    doubleCartridgeMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    onMaterialChange(e) {
      this.value.materialType2 = e;
      this.$store.commit(`${BLUETOOTH_MODULE_NAME}setMaterialType2`, e);
      this.$emit("input", this.value);
    },
    onTemperateChange(type) {
      switch (type) {
        case "t":
          break;
        case "p1":
          if (this.value.pushPower2 > 10) {
            this.value.pushPower2 = 10;
          }
          break;
        case "p2":
          if (this.value.proportion2 > 16) {
            this.value.proportion2 = 15;
          }
          break;
        case "i":
          if (this.value.integral2 > 16) {
            this.value.integral2 = 15;
          }
          break;
      }
      this.$emit("input", this.value);
    }
  },
  computed: {
    ...mapState("bluetooth", ["doubleR1"]),
    rightFlag() {
      if (this.doubleCartridgeMode) {
        return "(Right)";
      }
    }
  }
};
</script>

<style scoped lang="less">
.temperature {
  font-size: 14px;
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;

  .temperature-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
</style>
